export interface IEmailDomainRedirectConfig {
  // 支持多个邮箱后缀
  domains: string[];
  // 例如: '/studio/10cc'，redirectPath 必须以 / 开头
  redirectPath: string;
}

export const EMAIL_DOMAIN_REDIRECT_CONFIG: IEmailDomainRedirectConfig[] = [
  {
    domains: ['10chambers.com'],
    redirectPath: '/studio/10cc',
  },
];
